import { combineReducers } from 'redux';

import {
    ExpiryAdjustmentSlice,
    expiryAdjustmentSlice,
} from '@/features/slice/inventory';

import { apiSlice } from './slice/api-slice';
import auth, { AuthState } from './slice/auth';
import userSlice from './slice/auth/user-slice';
import customerSlice, { CustomerState } from './slice/customers/customer-slice';
import eventSlice, { EventState } from './slice/event/event-slice';
import filterSlice, { FilterState } from './slice/filter/filter-slice';
import paginationSlice, {
    PaginationState,
} from './slice/pagination/pagination-slice';
import productSlice, { ProductState } from './slice/products';
import { UserState } from './slice/users/types';

// Define the RootState type
export interface RootState {
    auth: AuthState;
    productSlice: ProductState;
    customerSlice: CustomerState;
    paginationSlice: PaginationState;
    filterSlice: FilterState;
    eventSlice: EventState;
    userSlice: UserState;
    expiryAdjustment: ExpiryAdjustmentSlice;
}

// Define the static reducers
const staticReducers = {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth,
    productSlice,
    customerSlice,
    eventSlice,
    userSlice,
    paginationSlice,
    filterSlice,
    [expiryAdjustmentSlice.reducerPath]: expiryAdjustmentSlice.reducer,
};

// Combine static reducers into the root reducer
const rootReducer = combineReducers(staticReducers);

export default rootReducer;
